
export const envConfig = {
  apiKey: '6AD64865-3796-444C-A00E-1864C9B93D9D',
  daDataUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs',
  daDataToken: '41af82a3c9de9ee06a826df2ed6008af5a410aa5',
  googleMapToken: 'AIzaSyBgqGG6tI64-0heU8QmPReeaQBD8-1pDKw',
  productionUrl: 'https://custom.justfood.pro',
  sentryDsn: 'https://fbba92a88b9641fcb0a598b0d7da5a0d@o516626.ingest.sentry.io/5645357',
};
